module.exports = __webpack_public_path__ + "static/img/11g.20f8f80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11g.jpg
// module id = 3L1P
// module chunks = 1